
import { useNavigate } from "react-router-dom";
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { AlertScreen } from "../../components/AlertScreen";
import { envVariables } from "../../../../helpers";
import { useBodegasStore } from "../../../../store";
const paginado = Number(envVariables.REACT_APP_PAGINADO);




export const TablaListBodegas = ({ data, chagePage=null, page=0 }) => {


    const navigate = useNavigate();
    const { totalBodega } = useBodegasStore();



    const handleOpcionesInfo = (id) => {
        navigate(`/admin/opcion/${id}/bodega`)
    }



    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'27%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'27%'}}>GRANJA</TableCell>
                                <TableCell sx={{width:'10%'}}>ALTO</TableCell>
                                <TableCell sx={{width:'10%'}}>ANCHO</TableCell>
                                <TableCell sx={{width:'10%'}}>LARGO</TableCell>
                                <TableCell sx={{width:'15%'}}>AREA</TableCell>
                                {/* <TableCell>OPCIONES</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.map( (bodega) => (
                            <TableRow key={ bodega.id } onClick={ () => handleOpcionesInfo(bodega.id) } sx={{cursor:'pointer'}}>
                                <TableCell>{ bodega.nombre }</TableCell>   
                                <TableCell>{bodega.granja?.nombre ?? 'Ninguna'}</TableCell>
                                <TableCell>{ bodega.alto }mt</TableCell>
                                <TableCell>{ bodega.ancho }mt</TableCell>
                                <TableCell>{ bodega.largo }mt</TableCell>
                                <TableCell>{ bodega.area }mt²</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalBodega / paginado)} disabled={Math.ceil(totalBodega / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay bodegas creadas por el momento..."/>
        }
        </>
    )
}
